export default "__VITE_ASSET__DGbvJl0k__"